module.exports = __webpack_public_path__ + "static/media/member nalas-09.f54eb77a.jpg";